import ContactUsPage from "components/contact-us/ContactUsPage"
import { GetStaticProps } from "next"
import { NextSeo } from "next-seo"
import { getContactUs } from "../../api"
import { getSiteIdByLocale } from "../../api/SiteId"

const ContactUs = ({ data }) => {
  return (
    <>
      <NextSeo
        title={data?.metaTitle}
        description={data?.metaDescription}
        additionalMetaTags={[{ name: "keywords", content: data.metaKeywords }]}
        openGraph={{
          title: data?.ogTitle || data?.metaTitle,
          description: data?.ogDescription || data?.metaDescription,
          images: [{ url: data?.ogImage?.media?.publicUrl || "" }],
        }}
      />
      <ContactUsPage data={data} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const siteId = getSiteIdByLocale(locale)
  const { data } = await getContactUs(siteId)

  return {
    props: {
      messages: (await import(`../../messages/${locale}.json`)).default,
      data,
    },
    revalidate: 60,
  }
}

export default ContactUs
